import { render, staticRenderFns } from "./OrganizationExamineeResultGrid2.vue?vue&type=template&id=028861cc&scoped=true&"
import script from "./OrganizationExamineeResultGrid2.vue?vue&type=script&lang=js&"
export * from "./OrganizationExamineeResultGrid2.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationExamineeResultGrid2.vue?vue&type=style&index=0&id=028861cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028861cc",
  null
  
)

export default component.exports